export default __webpack_public_path__ + "static/media/XRay.eeec3ee4.png";